module.exports = __webpack_public_path__ + "static/media/foto-perfil-2.fbb6fb56.png";